(function () {
  'use strict';

  var routes = (window.Theme && window.Theme.routes) || {};

  // Renders cents to a display string using the shop's money format.
  // The shop's format may contain HTML (e.g. <span class=money>${{amount}}</span>);
  // since we assign the result via textContent, strip any tags so the markup
  // never shows up as literal text next to the price.
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var format = (window.Theme && window.Theme.moneyFormat) || '${{amount}}';
    var out = format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals);
    if (out.indexOf('<') !== -1) {
      var tmp = document.createElement('div');
      tmp.innerHTML = out;
      out = (tmp.textContent || tmp.innerText || '').trim();
    }
    return out;
  }

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---------------- Search modal ---------------- */
  var searchModal = document.querySelector('[data-search-modal]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchTimer;

  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal && typeof searchModal.showModal === 'function') {
        searchModal.showModal();
        if (searchInput) searchInput.focus();
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal) searchModal.close();
    });
  });
  if (searchModal) {
    searchModal.addEventListener('click', function (event) {
      if (event.target === searchModal) searchModal.close();
    });
  }
  if (searchInput && routes.predictiveSearchUrl) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (term.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        var url =
          routes.predictiveSearchUrl +
          '?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url)
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="search-modal__empty">' + 'No results found' + '</p>';
              return;
            }
            searchResults.innerHTML = products
              .map(function (product) {
                var image = product.featured_image ? product.featured_image.url : '';
                return (
                  '<a class="search-modal__result" href="' +
                  product.url +
                  '">' +
                  (image ? '<img src="' + image + '" alt="" loading="lazy">' : '') +
                  '<span class="search-modal__result-title">' +
                  product.title +
                  '</span></a>'
                );
              })
              .join('');
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');

  function openCartDrawer() {
    if (cartDrawer && typeof cartDrawer.showModal === 'function') {
      cartDrawer.showModal();
    }
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.close();
  }
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', openCartDrawer);
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-cart-close]')) closeCartDrawer();
  });
  document.addEventListener('click', function (event) {
    if (cartDrawer && event.target === cartDrawer) closeCartDrawer();
  });

  function refreshCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (res) {
      return res.json();
    });
  }

  function reloadCartDrawer() {
    fetch(window.location.pathname + window.location.search)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && cartDrawer) {
          var wasOpen = cartDrawer.open;
          cartDrawer.replaceWith(fresh);
          cartDrawer = fresh;
          if (wasOpen) cartDrawer.showModal();
          bindCartDrawerEvents();
        }
      });
  }

  function bindCartDrawerEvents() {
    if (!cartDrawer) return;
    cartDrawer.querySelectorAll('[data-line-quantity]').forEach(function (wrap) {
      var line = wrap.getAttribute('data-line');
      var input = wrap.querySelector('[data-line-quantity-input]');
      var dec = wrap.querySelector('[data-quantity-decrease]');
      var inc = wrap.querySelector('[data-quantity-increase]');

      function changeLine(qty) {
        fetch(routes.cartChangeUrl || '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            refreshCartCount(cart);
            reloadCartDrawer();
          });
      }

      if (dec) {
        dec.addEventListener('click', function () {
          changeLine(Math.max(0, parseInt(input.value, 10) - 1));
        });
      }
      if (inc) {
        inc.addEventListener('click', function () {
          changeLine(parseInt(input.value, 10) + 1);
        });
      }
      if (input) {
        input.addEventListener('change', function () {
          changeLine(Math.max(0, parseInt(input.value, 10) || 0));
        });
      }
    });
  }
  bindCartDrawerEvents();

  /* Intercept every product add-to-cart form on the page (quick-add cards + PDP) */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = (window.Theme.strings && window.Theme.strings.adding) || submitBtn.textContent;
    }

    fetch(routes.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.fromEntries(new FormData(form).entries()))
    })
      .then(function (res) {
        return res.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        refreshCartCount(cart);
        reloadCartDrawer();
        setTimeout(openCartDrawer, 60);
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          if (originalText) submitBtn.textContent = originalText;
        }
      });
  });

  /* ---------------- Generic quantity steppers (PDP, standalone) ---------------- */
  document.addEventListener('click', function (event) {
    var decBtn = event.target.closest('[data-quantity-decrease]');
    var incBtn = event.target.closest('[data-quantity-increase]');
    var btn = decBtn || incBtn;
    if (!btn) return;
    var wrap = btn.closest('[data-quantity-selector]');
    if (!wrap) return;
    var input = wrap.querySelector('.quantity-selector__input');
    if (!input) return;
    var value = parseInt(input.value, 10) || 1;
    value = decBtn ? Math.max(1, value - 1) : value + 1;
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Sticky product bar reveal ---------------- */
  var stickyBar = document.querySelector('[data-sticky-buy-bar]');
  var buyBoxAnchor = document.querySelector('[data-buy-box-anchor]');
  if (stickyBar && buyBoxAnchor && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-72px 0px 0px 0px' }
    );
    observer.observe(buyBoxAnchor);
  }

  /* ---------------- Defer to a subscriptions app's own widget, if any ---------------- */
  var appManagedFallbacks = document.querySelectorAll('[data-app-managed-fallback]');
  if (appManagedFallbacks.length) {
    var APP_WIDGET_SELECTOR =
      '.sealsubs-container, [class*="subscription-widget"], [class*="selling-plan-widget"], [data-selling-plan-widget], [id*="subscription_app"]';

    function hideFallbacksIfAppPresent() {
      if (document.querySelector(APP_WIDGET_SELECTOR)) {
        appManagedFallbacks.forEach(function (fallback) {
          fallback.hidden = true;
        });
        return true;
      }
      return false;
    }

    if (!hideFallbacksIfAppPresent()) {
      var appWidgetObserver = new MutationObserver(function () {
        if (hideFallbacksIfAppPresent()) appWidgetObserver.disconnect();
      });
      appWidgetObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () {
        appWidgetObserver.disconnect();
      }, 8000);
    }
  }

  /* ---------------- Selling plan (one-time vs subscribe) toggle ---------------- */
  document.querySelectorAll('[data-purchase-option]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var form = radio.closest('form');
      if (!form) return;
      var sellingPlanInput = form.querySelector('[data-selling-plan-input]');
      var frequencySelect = form.querySelector('[data-selling-plan-select]');
      if (!sellingPlanInput) return;
      if (radio.value === 'subscription') {
        sellingPlanInput.value = frequencySelect ? frequencySelect.value : sellingPlanInput.dataset.defaultPlan || '';
        sellingPlanInput.disabled = false;
        if (frequencySelect) frequencySelect.disabled = false;
      } else {
        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true;
        if (frequencySelect) frequencySelect.disabled = true;
      }
    });
  });
  document.querySelectorAll('[data-selling-plan-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      var sellingPlanInput = form && form.querySelector('[data-selling-plan-input]');
      if (sellingPlanInput && !sellingPlanInput.disabled) {
        sellingPlanInput.value = select.value;
      }
    });
  });

  /* ---------------- Gallery thumbnails ---------------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var wrap = thumb.closest('.pdp__gallery');
      if (!wrap) return;
      var mainImg = wrap.querySelector('[data-gallery-main] img');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full-src');
      wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---------------- Variant picker ---------------- */
  document.querySelectorAll('[data-product-json]').forEach(function (script) {
    var form = script.closest('form');
    if (!form) return;
    var product;
    try {
      product = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    var optionSelectors = Array.from(form.querySelectorAll('[data-option-selector]'));
    var variantInput = form.querySelector('[data-variant-id]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var submitPrice = form.querySelector('[data-submit-price]');
    var priceWrap = form.closest('.pdp') ? form.closest('.pdp').querySelector('[data-price-wrap]') : null;

    function findVariant() {
      var selected = optionSelectors.map(function (s) {
        return s.value;
      });
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return selected.length === 0 || opt === selected[i];
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (submitPrice) submitPrice.textContent = formatMoney(variant.price);
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
      }
      if (priceWrap) {
        var amountEl = priceWrap.querySelector('.price__amount');
        if (amountEl) amountEl.textContent = formatMoney(variant.price);
        var compareEl = priceWrap.querySelector('.price__compare');
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
      }
      // Keep any subscribe-option price in sync with the selected variant.
      var subPriceEl = form.querySelector('[data-subscription-price]');
      if (subPriceEl) {
        var pct = parseFloat(subPriceEl.getAttribute('data-discount-percent') || '15');
        subPriceEl.textContent = formatMoney(Math.round(variant.price * (1 - pct / 100)));
      }
      var oneTimePriceEl = form.querySelector('[data-one-time-price]');
      if (oneTimePriceEl) oneTimePriceEl.textContent = formatMoney(variant.price);
    }

    optionSelectors.forEach(function (select) {
      select.addEventListener('change', function () {
        updateForVariant(findVariant());
      });
    });
  });
})();
